/**
 * MC Card Slider Defer v1.2 (2026-06-10 Hotfix 2)
 * v1.1-Problem: IO-Hydration (400px) -> Browser startet Bild-Downloads zu spaet,
 * auf Mobile sichtbar langsames Nachladen beim Scrollen.
 * v1.2: Hydration ALLER Slider sofort nach DOM-Ready (Idle-Zeit). Die <img> haben
 * loading="lazy" -> der Browser uebernimmt das Vorausladen mit nativen Schwellwerten
 * (~1-3 Viewports), exakt wie vor dem Refactoring. HTML bleibt klein (Server rendert
 * weiterhin nur 2 Bilder); nur das DOM waechst clientseitig zurueck.
 * Aktive Slides (aria-current/Swatch-Anchor) bekommen loading=eager.
 */
(function(){
  'use strict';
  function hydrate(slider){
    if(!slider || slider.dataset.mcHydrated) return;
    slider.dataset.mcHydrated='1';
    var cls=slider.dataset.mcImgClass||'img-fit card__main-image';
    var sizes=slider.dataset.mcSizes||'';
    slider.querySelectorAll('li.mc-defer-slide > a').forEach(function(a){
      if(a.querySelector('img')) return;
      var li=a.closest('li');
      var img=document.createElement('img');
      img.src=a.getAttribute('data-src');
      img.alt=a.getAttribute('data-alt')||'';
      /* Aktiver Slide (Swatch-Anchor/aria-current) sofort laden, Rest nativ-lazy */
      img.loading=(li&&li.hasAttribute('aria-current'))?'eager':'lazy';
      img.decoding='async';
      img.className=cls;
      if(sizes) img.setAttribute('sizes',sizes);
      if(li&&li.dataset.mediaId) img.setAttribute('data-media-id',li.dataset.mediaId);
      a.appendChild(img);
    });
  }
  function hydrateAll(root){
    (root||document).querySelectorAll('product-card-image-slider:not([data-mc-hydrated])').forEach(hydrate);
  }
  function start(){
    if('requestIdleCallback' in window){
      requestIdleCallback(function(){ hydrateAll(); },{timeout:800});
    } else {
      setTimeout(hydrateAll,0);
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',start);
  } else { start(); }
  /* Nachgeladene Karten (Pagination/AJAX/Filter) */
  new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      if(muts[i].addedNodes.length){ hydrateAll(); break; }
    }
  }).observe(document.documentElement,{childList:true,subtree:true});
  /* Interaktions-Fallback (greift vor Idle, z. B. sehr schneller Swatch-Klick) */
  function onInteract(e){
    if(!e.target||!e.target.closest) return;
    var slider=e.target.closest('product-card-image-slider');
    if(slider) hydrate(slider);
  }
  document.addEventListener('pointerover',onInteract,{capture:true,passive:true});
  document.addEventListener('touchstart',onInteract,{capture:true,passive:true});
  document.addEventListener('change',function(e){
    if(!e.target||!e.target.closest) return;
    var card=e.target.closest('product-card');
    if(card) hydrate(card.querySelector('product-card-image-slider'));
  },true);
})();
